export const CONNECT_SKVLLPVNKZ = 'CONNECT_SKVLLPVNKZ';
export const UPDATE_SKVLLPVNKZ_LIST = 'UPDATE_SKVLLPVNKZ_LIST';
export const DISPOSE_USED_SKVLLPVNKZ = 'DISPOSE_USED_SKVLLPVNKZ';
export const RESET_SKVLLPVNKZ_STATE = 'RESET_SKVLLPVNKZ_STATE';
